import { DateTime } from 'luxon';

import { Campaign } from 'apis/restaurant-api/merchant-admin/campaigns/types';

import { CampaignStatus } from '../types';

export const getCampaignStatus = (campaign?: Campaign): CampaignStatus | undefined => {
  if (!campaign) {
    return;
  }

  if (campaign.terminated) {
    return CampaignStatus.CANCELLED;
  }

  const startDateObj = DateTime.fromISO(campaign.start_date);
  const endDateObj = DateTime.fromISO(campaign.end_date);
  const now = DateTime.local();
  const isOutOfBudget = !campaign.total_budget_sum
    ? false
    : (campaign.total_spent_budget || 0) >= campaign.total_budget_sum;

  if (now > startDateObj && now < endDateObj && !isOutOfBudget) {
    return CampaignStatus.RUNNING;
  }

  if (startDateObj > now) {
    return CampaignStatus.SCHEDULED;
  }

  if (endDateObj < now || isOutOfBudget) {
    return CampaignStatus.COMPLETED;
  }

  return CampaignStatus.SCHEDULED;
};
